import ChecklistProtocolPersonBusiness from "@/business/ChecklistProtocolPersonBusiness";
import CertificateProtocolBusiness from "@/business/CertificateProtocolBusiness";
import {TYPE_OF_CERTIFICATES} from "@/constants/TypeOfCertificates";

const certificateTypeName = (typeOfCertificate) => {
    const type = TYPE_OF_CERTIFICATES.find(t => t.id === typeOfCertificate);
    return type ? type.name : typeOfCertificate;
};

const extractPendingPersons = (checklistList) => {
    const persons = [];
    const collect = (checklist) => {
        if(!checklist){
            return;
        }
        const pendingTypes = (checklist.certificates || [])
            .filter(certificate => CertificateProtocolBusiness.calculateProgress(certificate) < 100)
            .map(certificate => certificateTypeName(certificate.typeOfCertificate));
        if(pendingTypes.length > 0){
            persons.push({name: checklist.person.name, pendingTypes});
        }
        (checklist.children || []).forEach(collect);
    };
    (checklistList || []).forEach(collect);
    return persons;
};

const escapeHtml = (text) => {
    return String(text)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
};

const calculateProtocolProgress = (checklistList) => {
    const certificates = (checklistList || []).flatMap(checklist => CertificateProtocolBusiness.getAllCertificates(checklist));
    return CertificateProtocolBusiness.calculateProgressCertificates(certificates);
};

const progressColor = (percent) => {
    if(percent < 20){
        return '#E74C3C';
    } else if(percent < 60){
        return '#fadb14';
    } else if(percent < 80){
        return '#13c2c2';
    } else if(percent < 100){
        return '#00bc8c';
    } else {
        return '#389e0d';
    }
};

const buildProgressBarHtml = (progress) => {
    const percent = Math.max(0, Math.min(100, progress || 0));
    return `<div class="checklist-status-progress">Checklist status: <div class="checklist-status-progress-bar"><div class="checklist-status-progress-fill" style="width:${percent}%;background-color:${progressColor(percent)};"></div></div><span>${percent}%</span></div>`;
};

const summarizePendingPersons = (pendingPersons, maxItems = 5) => {
    const persons = pendingPersons || [];
    const items = persons.slice(0, maxItems)
        .map(person => {
            const types = person.pendingTypes.map(type => `<li>${escapeHtml(type)}</li>`).join('');
            return `<li>${escapeHtml(person.name)}<ul>${types}</ul></li>`;
        });
    if(persons.length > maxItems){
        items.push('<li>...</li>');
    }
    return `<ul class="checklist-status-list">${items.join('')}</ul>`;
};

export default {

    async getChecklistStatus(protocolId){
        const checklistProtocolPerson = await ChecklistProtocolPersonBusiness.getByProtocolId(protocolId);
        return {
            progress: calculateProtocolProgress(checklistProtocolPerson),
            pendingPersons: extractPendingPersons(checklistProtocolPerson),
        };
    },

    async getPendingPersonsByProtocolId(protocolId){
        const checklistProtocolPerson = await ChecklistProtocolPersonBusiness.getByProtocolId(protocolId);
        return extractPendingPersons(checklistProtocolPerson);
    },

    extractPendingPersons,
    summarizePendingPersons,
    buildProgressBarHtml,

}
